<mat-card class="card-wrapper mx-object-form two-col-big"
          [ngClass]="{'object-form-readonly': (formMode$$ | async) === 'readonly',
                      'object-form-edit-mode': (formMode$$ | async) === 'edit'}">
    <mat-card-header *ngIf="showHeader()"  class="mxs-card-header">
        <mx-button id="backButton" *ngIf="props.showNavigation" [buttonModel]="backButton"></mx-button>
        <mat-card-title>{{getFormTitle() | translate}} <span *mxInfo="props.informationKey + '_' + formMode$$.value"></span></mat-card-title>
        <ng-container *ngIf="pageActions">
            <ng-container *ngFor="let pageAction of pageActions">
                <button *ngIf="hasActionPermission(pageAction)" (click)="pageAction.action()" class="mxs-button mxs-button--secondary">{{pageAction.name}}</button>
            </ng-container>
        </ng-container>
        <ng-content select="mx-form-header"></ng-content>
    </mat-card-header>
    <mat-card-content [ngClass]="{'multiple-columns': route.snapshot.data.threeColumns || isMultipleColumns()}">

        <mx-form #boForm
                 (customize)="onCustomize($event)"
                 [formMode]="(formMode$$ | async)"
                 [layoutClass]="route.snapshot.data.layoutClass"
        >
            <ng-container ngProjectAs="mx-form-footer">
                <ng-content select="mx-form-footer"></ng-content>
            </ng-container>
        </mx-form>

    </mat-card-content>
    <mat-card-actions>
        <ng-content select="mx-form-custom-actions"></ng-content>
        <div *ngIf="customActions.length > 0" class="buttons-to-left">
            <mx-button *ngFor="let model of customActions" [buttonModel]="model"></mx-button>
        </div>
        <div *ngIf="copyPasteFunctionality" class="buttons-to-left">
                <mx-button *ngIf="hasPastePermission()"
                           [buttonModel]="pasteButton"
                ></mx-button>
                <mx-button *ngIf="hasCopyPermission()"
                           [buttonModel]="copyButton"
                ></mx-button>
        </div>

        <ng-container *ngIf="actionsConfig!.cancel!.visible">
            <mx-button [buttonModel]="cancelButton"></mx-button>
        </ng-container>
        <ng-container *ngIf="form && actionsConfig!.submit!.visible">
            <mx-button [buttonModel]="submitButton" cdkFocusInitial></mx-button>
        </ng-container>
    </mat-card-actions>
</mat-card>

<ng-content select="mx-after-actions"></ng-content>
